module.exports = __webpack_public_path__ + "static/media/near_west_hill.947b61a0.jpg";